import React, { ReactNode } from 'react';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { Icons, SVG } from '../../../atoms/SVG';
import { GetHeadlineAndPosition, HeadlineType } from '../BlockInteractionsTypes';

type HeadlineInfoType = {
  isInLayoutGroup?: boolean;
  headline: HeadlineType;
  headingRef: React.RefObject<HTMLHeadingElement | null>;
  info?: ReactNode;
  getHeadlinePosition: GetHeadlineAndPosition;
};

/**
 * Always returns a headline, but it can be invisible
 * Wrapping component decides hierarchy
 * Sometimes returns additional stuff, which can be another component
 */
export function HeadlineInfo({ isInLayoutGroup, headline, headingRef, info, getHeadlinePosition }: HeadlineInfoType) {
  return (
    <>
      <Heading
        hierarchy={isInLayoutGroup ? headline.hierarchy + 1 : headline.hierarchy}
        ref={headingRef}
        className={headline.visible ? 'block-interactions__headline' : 'invisible'}
      >
        {isInLayoutGroup && (
          <span className="block-interactions__layout-group-indicator" aria-hidden="true">
            <SVG svgSpriteId={Icons.CONNECT_BLOCKS} svgClass="block-interactions__layout-group-indicator-svg" />
          </span>
        )}
        {headline.text}
        {getHeadlinePosition() && (
          <span className="block-interactions__headline-position">&nbsp;{getHeadlinePosition()}</span>
        )}
      </Heading>
      {info || null}
    </>
  );
}
